import React, { useState, useEffect } from "react";
import CareerPageHeader from "./careerPageHeader";
import Footer from "../../common/footer";
import Header from "../../common/header";
import { Form } from "react-router-dom";

const ApplyForm = () => {
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState(null); // Form submission feedback

    useEffect(() => {
        const fetchData = async () => {
            try {
                console.log("Fetching roles...");
                const response = await fetch(`https://tita.itrain.io/career/get?t=${new Date().getTime()}`);
                const data = await response.json();
                console.log("Fetched data:", data);

                if (data && data.career) {
                    setRoles(data.career);
                } else {
                    console.warn("Career data not available.");
                    setRoles([]);
                }
            } catch (error) {
                console.error("Error fetching roles:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);

        const data = {
            name: formData.get("q-full-name"),
            email: formData.get("q-email"),
            exp: formData.get("q-experience"),
            role: formData.get("q-role"),
            mobile: formData.get("q-phone"),
            location: formData.get("q-work-type"),
            yourmessage: formData.get("q-job-description"),
            address: formData.get("q-address"),
        };

        // File Upload Handling
        const resume = formData.get("q-cv");

        const finalData = new FormData();
        for (let key in data) {
            finalData.append(key, data[key]);
        }
        finalData.append("cv", resume);
        console.log("Final Data:", finalData);
        try {
            const response = await fetch("https://tita.itrain.io/career/createUserdetails", {
                method: "POST",
                body: finalData, // Send FormData directly (no JSON.stringify)
            });
            console.log("Response:", response);
            const responseData = await response.json();
            setMessage({ type: "success", text: "Application submitted successfully!" });
        } catch (error) {
            console.error(error);
            setMessage({ type: "error", text: "Submission failed. Please try again." });
        }
    };

    return (
        <>
            <Header />
            <div id="searchbox-overlay" />

            <section className="contact-section padding">
                <div className="map-pattern" />
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 sm-padding">
                            <div className="contact-form-wrap row-gap">
                                <div className="section-heading mb-20">
                                    <h2 className="text-anim">Apply <span className="hl">here</span></h2>
                                    <p className="text-anim">Grow with our team. Apply for your job role here.</p>
                                </div>

                                <div className="contact-form">
                                    <form onSubmit={handleSubmit}>
                                        <div className="contact-form-group">
                                            {/* Name */}
                                            <div className="form-field w-full mb-2">
                                                <input type="text" name="q-full-name" className="form-control w-full" placeholder="Your Name" required />
                                            </div>

                                            {/* Email */}
                                            <div className="form-field w-full mb-2">
                                                <input type="email" name="q-email" className="form-control w-full" placeholder="Your Email" required />
                                            </div>

                                            {/* Experience */}
                                            <div className="form-field w-full mb-2">
                                                <select name="q-experience" className="form-control w-full">
                                                    <option value="0-1">0-1 Year</option>
                                                    <option value="1-5">1-5 Years</option>
                                                    <option value="5-10">5-10 Years</option>
                                                    <option value="above-10">Above 10 Years</option>
                                                </select>
                                            </div>

                                            {/* Role Dropdown */}
                                            <div className="form-field w-full mb-2">
                                                <select name="q-role" className="form-control w-full">
                                            {  roles.length > 0 &&
                                                        roles.map((role) => <option key={role._id} value={role.title}>{role.title}</option>) 
                                                       
                                                    }
                                                </select>
                                            </div>

                                            {/* CV Upload */}
                                            <div className="form-field w-full mb-2">
                                                <input type="file" name="q-cv" className="form-control w-full" required />
                                            </div>

                                            {/* Phone */}
                                            <div className="form-field w-full mb-2">
                                                <input type="tel" name="q-phone" className="form-control w-full" placeholder="Your Phone" required />
                                            </div>

                                            {/* Work Type */}
                                            <div className="form-field w-full mb-2">
                                                <select name="q-work-type" className="form-control w-full">
                                                    <option value="hybrid">Hybrid</option>
                                                    <option value="full-time">Full-Time</option>
                                                    <option value="part-time">Part-Time</option>
                                                </select>
                                            </div>

                                            {/* Job Description */}
                                            <div className="form-field w-full mb-2">
                                                <textarea name="q-job-description" cols={30} rows={4} className="form-control w-full" placeholder="Job Description (optional)" />
                                            </div>

                                            {/* Address */}
                                            <div className="form-field w-full mb-2">
                                                <textarea name="q-address" cols={30} rows={4} className="form-control w-full" placeholder="Your Address" />
                                            </div>

                                            {/* Submit Button */}
                                            <div className="form-field submit-btn">
                                                <button className="default-btn" type="submit">
                                                    Apply Now
                                                </button>
                                            </div>
                                        </div>
                                    </form>

                                    {/* Submission Feedback */}
                                    {message && (
                                        <div className={`alert ${message.type === "success" ? "alert-success" : "alert-danger"}`}>
                                            {message.text}
                                        </div>
                                    )}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default ApplyForm;
